module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_ko-2abbbc7928d137e951d7fe4c303e2dc2.jpg";